import Config from '../Config';
import {RestService} from './RestService';
import moment from 'moment';
import { format_without_time, format } from '../Utils';

export const WarehouseService = {
    getWarehouseList: async function(start, numberItems, filter, sort, direction){
        return RestService.get(`${Config.get_warehouses_url}from=${start}&offset=${numberItems}&filter=${filter}&sort=${sort}&direction=${direction}`, {})
        .then(response => response.json());
    },
    getStock: async function(id = undefined){
        return RestService.get(`${Config.get_warehouse_stock_url}${ id ? `source_id=${id}`: ""}`, {})
        .then(response => response.json());
    },
    remove: async function(id, headers = {}) {
        return RestService.get(`${Config.remove_wh}id=${id}`, headers)
        .then(response => response.json());
    },
    createModify: async function(body, headers = {}) {
        return RestService.post(`${Config.create_wh}`, headers, body)
        .then(response => response.json());
    },
    toggleStatus:  async function(id) {
        return RestService.get(`${Config.toggle_wh_status}id=${id}`, {})
        .then(response => response.json())
    },
    getTotalCount: async function(type, startdate, enddate, products, source_id, destination_id, stock_type, reasons) {
        return RestService.get(`${Config.total_count}data_type=INVENTORY_TRANSACTIONS&type=${type}&startdate=${startdate}&enddate=${enddate}${ products ? `&products=${products}` : '' }${ source_id ? `&source_id=${source_id}` : '' }${ destination_id ? `&destination_id=${destination_id}` : '' }${ stock_type ? `&stock_type=${stock_type}` : '' }${ reasons ? `&reasons=${reasons}` : '' }`, {})
        .then(response => response.json());
    },
    getTransactions: async function(start, numberItems, startdate, enddate, products, source_id, destination_id, stock_type, reasons) {
        return RestService.get(`${Config.get_inventory_transactions}from=${start}&offset=${numberItems}&startdate=${moment(startdate).format(format_without_time)}&enddate=${moment(enddate).format(format_without_time)}${ products ? `&products=${products}` : '' }${ source_id ? `&source_id=${source_id}` : '' }${ destination_id ? `&destination_id=${destination_id}` : '' }${ stock_type ? `&stock_type=${stock_type}` : '' }${ reasons ? `&reasons=${reasons}` : '' }`, {})
        .then(response => response.json());
    },
    getTransactionDetail: async function(transaction_id) {
        return RestService.get(`${Config.get_inventory_transaction_details}id=${transaction_id}`, {})
        .then(response => response.json());
    },
    createTransaction: async function(header = {}, body){
        return RestService.post(`${Config.create_inventory_transaction}`, header, body)
                .then(response => response.json());
    },
    getTransactionForSandD: async function(source_id, destination_id, type, txnDate) {
        return RestService.get(`${Config.get_inventory_transactions_for_sd}source=${source_id}&destination=${destination_id}&type=${type}&txnDate=${moment(txnDate).format(format_without_time)}`, {})
        .then(response => response.json());
    },
    getStockSummary: async function() {
        return RestService.get(`${Config.get_inventory_summary}`, {})
        .then(response => response.json());
    },
    getBatchwiseStockSummaryForProduct: async function(product_id, warehouse_id) {
        return RestService.get(`${Config.get_inventory_batchwise_summary}product_id=${product_id}&warehouse_id=${warehouse_id}`, {})
        .then(response => response.json());
    },
    removeTransaction: async function(id, header = {}){
        return RestService.get(`${Config.remove_inventory_transaction}transaction_id=${id}`, header)
        .then(response => response.json());
    },
    getWarehouseReasons: async function(){
        return RestService.get(`${Config.get_warehouse_reasons_url}`, {})
        .then(response => response.json());
    },
    removeReason: async function(code, header = {}) {
        return RestService.get(`${Config.remove_wh_reason}code=${code}`, header)
        .then(response => response.json());
    },
    removeReasonOwnership: async function(code, header = {}) {
        return RestService.get(`${Config.remove_wh_reason_ownership}code=${code}`, header)
        .then(response => response.json());
    },
    assignOwnership: async function(body, headers = {}){
        return RestService.post(`${Config.assign_wh_reason_ownership}`, headers, body)
        .then(response => response.json());
    },
    createReason: async function(body){
        return RestService.post(`${Config.create_wh_reason}`, {}, body)
                .then(response => response.json());
    },
    getDailyInventoryReport: async function(schedule_date, startdate, enddate){
        return RestService.get(`${Config.report_daily_inventory_url}schedule_date=${schedule_date.format(format_without_time)}&startdate=${startdate.format(format)}&enddate=${enddate.format(format)}`, {})
        .then(response => response.json());
    },
    getInventoryOpeningReport: async function(startdate, enddate, product_id, source_id){
        return RestService.get(`${Config.report_inventory_opening_stock_url}startdate=${startdate}&enddate=${enddate}&product_id=${product_id}&source_id=${source_id}`, {})
        .then(response => response.json());
    },
    updateStockMismatch: async function(header = {}, body){
        return RestService.post(`${Config.update_inventory_mismatch}`, header, body)
                .then(response => response.json());
    },
    getInventoryMismatchReport: async function(startdate, stock_type, source_id){
        return RestService.get(`${Config.report_inventory_mismatch_stock_url}startdate=${startdate}&stock_type=${stock_type}&source_id=${source_id}`, {})
        .then(response => response.json());
    },
    getDailyInventorySpecialReport: async function(startdate, enddate, warehouse_id, farm_id, farm_id_return, action = 'download'){
        return RestService.get(`${Config.daily_inventory_report_url}startdate=${moment(startdate).startOf('day').format(format)}&enddate=${moment(enddate).endOf('day').format(format)}&warehouse_id=${warehouse_id}&farm_id=${farm_id}&farm_id_return=${farm_id_return}&action=${action}`, {});
    },
};